import React from "react";
import styles from "./WidgetAppearanceForm.module.css";
import {BotType} from "../../../../../../../api/generated";
import {WidgetView} from "./components/WidgetView";
import {PromptPopupView} from "./components/PromptPopupView";
import {GeneralSettings} from "./components/GeneralSettings";
import {VehicleButtonCustomization} from "./components/VehicleButtonsCustomization/VehicleButtonCustomization";
import {FooterMessageView} from "./components/FooterMessageView";
import {TermsView} from "./components/TermsView";
import {AnalyticsSettings} from "./components/AnalyticsSettings";
import {
    EnablePersonalizedVehicleDescriptionComponent
} from "./components/EnablePersonalizedVehicleDescriptionComponent/EnablePersonalizedVehicleDescriptionComponent";
import {LocaleSettings} from "./components/LocaleSettings";
import {AssistantPersona} from "./components/AssistantPersona";

interface Props {
    botType: BotType;
    getMessageWrapper: (field: string) => string;
    updateValidationStatus: any;
}

export const WidgetAppearanceForm: React.FC<Props> = ({botType, getMessageWrapper, updateValidationStatus}) => (
    <div className={styles.formWrapper}>
        <LocaleSettings botType={botType}/>

        <AssistantPersona
            getMessageWrapper={getMessageWrapper}
            updateValidationStatus={updateValidationStatus}
        />

        <GeneralSettings
            getMessageWrapper={getMessageWrapper}
            updateValidationStatus={updateValidationStatus}
        />

        <FooterMessageView
            getMessageWrapper={getMessageWrapper}
            updateValidationStatus={updateValidationStatus}
        />

        <TermsView
            getMessageWrapper={getMessageWrapper}
            updateValidationStatus={updateValidationStatus}
        />

        <PromptPopupView
            getMessageWrapper={getMessageWrapper}
            updateValidationStatus={updateValidationStatus}
        />

        <WidgetView
            getMessageWrapper={getMessageWrapper}
            updateValidationStatus={updateValidationStatus}
        />

        <VehicleButtonCustomization
            getMessageWrapper={getMessageWrapper}
            updateValidationStatus={updateValidationStatus}
        />

        <EnablePersonalizedVehicleDescriptionComponent/>

        <AnalyticsSettings
            getMessageWrapper={getMessageWrapper}
            updateValidationStatus={updateValidationStatus}
        />
    </div>
);
